__turbopack_context__.v({
  "arrow": "izNGsa_arrow",
  "arrowDisabled": "izNGsa_arrowDisabled",
  "arrowRight": "izNGsa_arrowRight",
  "wrapper": "izNGsa_wrapper",
});
